/* eslint-disable */
import { Loader } from "@googlemaps/js-api-loader";

var geocoder = null;
var map;
var markers = [];
var visibleMarkersCount = 0;
var countOfMarkers = 6;
const markerIcon = "/wp-content/themes/arturo/dist/images/marker.svg";

const loader = new Loader({
	apiKey: "AIzaSyACJ12YLBvQstgM9OGjpfR4hA43fSpc434",
	version: "weekly",
	libraries: ["geometry"],
});

const getQueryParameter = (param) =>
	new URLSearchParams(document.location.search.substring(1)).get(param);

const createMap = (google) => {
	const mapOptions = {
		backgroundColor: "#666666",
		zoom: 8,
		center: {
			lat: 52.377956,
			lng: 3.75,
		},
		disableDefaultUI: true,
	};

	map = new google.maps.Map(document.getElementById("map"), mapOptions);

	geocoder = new google.maps.Geocoder();
	return map;
};

function delay(callback, ms) {
	var timer = 0;
	return function () {
		var context = this,
			args = arguments;
		clearTimeout(timer);
		timer = setTimeout(function () {
			callback.apply(context, args);
		}, ms || 0);
	};
}

function focusLocations() {
	const bounds = new google.maps.LatLngBounds();

	$.each(markers, function () {
		var latlng = new google.maps.LatLng(
			this.getPosition().lat(),
			this.getPosition().lng()
		);

		if (this.getVisible()) {
			bounds.extend(latlng);
		}
	});

	map.fitBounds(bounds); //auto-zoom
	map.panToBounds(bounds);

	var storeBox = $(".store-locator-search");

	var offsetX = (storeBox.width() + storeBox.position().left) / 2 - 100;

	if ($(document).width < 992) {
		offsetX = 0;
	}

	// google.maps.event.addListenerOnce(map, 'idle', function () {
	// 	offsetCenter(map, bounds.getCenter(), offsetX, 0);
	// });
}

// const renderServices = (services) => {

// 	if (services && services.length > 0) {
// 		// Map through the services array and extract the opening hours
// 		const services = services.map(service => service.services);

// 		// Join the opening hours with line breaks
// 		return `<p><span class="text-secondary">${services}</span><br />${services.join("<br />")}</p>`;
// 	} else {
// 		return "";
// 	}
// };

const createMarkers = (dealers, map) => {
	var infoWindow = new google.maps.InfoWindow();

	dealers.forEach((dealer) => {
		let template = renderTemplate(dealer);
		let LatLng = new google.maps.LatLng(dealer.lat, dealer.long);

		let marker = new google.maps.Marker({
			position: LatLng,
			map,
			icon: markerIcon,
			data: {
				title: dealer.title,
				city: dealer.city,
				address: dealer.address,
				zipcode: dealer.zipcode,
				city: dealer.city,
				phone: dealer.phone,
				opening_hours: dealer.opening_hours,
				website: dealer.link,
				services: dealer.services,
			},
		});

		marker.addListener("click", () => {
			infoWindow.close();
			infoWindow.setContent(template);
			infoWindow.open(marker.getMap(), marker);
			map.panTo(marker.getPosition());
		});

		markers.push(marker);

		google.maps.event.addListenerOnce(map, "idle", function () {
			focusLocations();
		});
	});
};

if (document.querySelector(".page-template-store-locator") != null) {
	loader.load().then((google) => {
		if (document.querySelector(".page-template-store-locator") === null) {
			return;
		}

		var map = createMap(google);
		var dealers = parseDealers();
		createMarkers(dealers, map);

		if (getQueryParameter("zipcode")) {
			const geocodedInput = codeAddress(getQueryParameter("zipcode"));

			geocodedInput.then((data) => {
				sortMarkers(data.geometry.location);

				var closestN = [];
				var foundCount = 0;
				let dealerCards = [];

				$.each(markers, function () {
					if (foundCount < countOfMarkers) {
						this.setVisible(true);
						this.hiddenBySearch = false;
						foundCount++;
						dealerCards.push(this);
					} else {
						this.setVisible(false);
						this.hiddenBySearch = true;
					}
				});

				$(".dealer-list").empty();
				$(".js-dealer-more");

				for (var i = 0; i < dealerCards.length; i++) {
					$(".dealer-list").append(renderDealerCard(dealerCards[i]));
				}

				focusLocations();
			});
		}

		$(".js-dealer-input").keyup(
			delay(function (e) {
				if (
					!$(this).val() ||
					$(this).val().length < 3 ||
					e.keyCode === 27 ||
					e.code === "Space"
				) {
					if ($(this).val().length == 0) {
						resetMarkers();
					}
					// Removing the query parameter if the input length is less than 3
					const currentUrl = new URL(window.location.href);
					currentUrl.searchParams.delete("location");
					history.pushState({ path: currentUrl.href }, "", currentUrl.href);
					return;
				}

				const geocodedInput = codeAddress($(this).val());

				geocodedInput.then((data) => {
					// Updating the URL
					const newUrl = new URL(window.location.href);
					newUrl.searchParams.set("location", $(this).val());
					history.pushState({ path: newUrl.href }, "", newUrl.href);

					sortMarkers(data.geometry.location);

					var closestN = [];
					var foundCount = 0;
					let dealerCards = [];

					$.each(markers, function () {
						if (foundCount < countOfMarkers) {
							this.setVisible(true);
							this.hiddenBySearch = false;
							foundCount++;

							dealerCards.push(this);
						} else {
							this.setVisible(false);
							this.hiddenBySearch = true;
						}
					});

					$(".dealer-list").empty();
					$(".js-dealer-more").remove();

					for (var i = 0; i < dealerCards.length; i++) {
						$(".dealer-list").append(renderDealerCard(dealerCards[i]));
					}

					focusLocations();
				});
			}, 500)
		);
	});
}

const getMapLink = (address, zipcode, city) => {
	const baseUrl = "https://www.google.nl/maps/place/";

	address = address.replace(/ /g, "+");
	zipcode = zipcode.replace(/ /g, "+");
	city = city.replace(/ /g, "+");

	return baseUrl + address + "+" + zipcode + "+" + city;
};

const renderDealerCard = (data) => {
	let dealer = data.data;
	let distance = data.distance / 1000;
	distance = distance.toFixed(0);

	return `
	<div class="col-lg-6 dealer-list__col">

<div class="card-dealer">
	<h4 class="card-dealer__title">
		<span class="card-dealer__title--highlight">Arturo</span>
					<span>${dealer.city}</span>
			</h4>

			<div class="card-dealer__header">
				<span class="card-dealer__bold">${dealer.title}</span>
				<span class="card-dealer__bold js-distance">${distance} Km</span>
			</div>

	<div class="card-dealer__row">
		<div class="card-dealer__left">
			<p>
				${dealer.address} <br>
				${dealer.zipcode} ${dealer.city} <br>
				${dealer.phone}
			</p>
		</div>

		<div class="card-dealer__right">
			<p>
				${renderOpeningHours(dealer.opening_hours)}
			</p>
		</div>
	</div>

	<div class="card-dealer__footer">
		<a href="${
			dealer.website
		}" target="_blank" class="btn btn--primary btn--has-icon">${
		arturo_vars.dealer_visit_website
	}</a>

		<a target="_blank" href="${getMapLink(
			dealer.address,
			dealer.zipcode,
			dealer.city
		)}" class="card-dealer__route">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 41">
				<path fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M57.556051 20.5 29.778297 2v9.277753c-6.944846.777636-13.111513 3.888722-18.5 9.277754C5.889266 25.889031 2.77818 32.055698 2 39c5.055992-4.777915 9.666843-7.833495 13.889149-9.277753 4.222305-1.388752 8.833157-1.388752 13.889148 0V39l27.777754-18.5Z"></path>
			</svg>
		</a>
	</div>
	</div>
</div>`;
};

/**
 *
 * @param {We need the language} input
 * @returns
 */
const codeAddress = (input) => {
	return new Promise(function (resolve, reject) {
		geocoder.geocode(
			{
				address: input,
			},
			function (results, status) {
				if (status == "OK") {
					resolve(results[0]);
				} else {
					reject(status);
				}
			}
		);
	});
}; // expose global init

const sortMarkers = (location) => {
	$.each(markers, function () {
		this.distance = google.maps.geometry.spherical.computeDistanceBetween(
			this.getPosition(),
			location
		);
	});

	markers.sort(compareDistance);
};

const renderPhone = (phoneNumber) => {
	if (phoneNumber) {
		return phoneNumber;
	} else {
		return "";
	}
};

const renderOpeningHours = (openingHours) => {
	if (openingHours) {
		return `<p><span class="text-secondary">${arturo_vars.dealer_opening_hours}</span> <br />${openingHours}</p>`;
	} else {
		return "";
	}
};

const parseDealers = () => {
	var jsonField = document.getElementById("dealer-data");
	var input = jsonField.textContent;
	const dealers = JSON.parse(input);

	return dealers;
};

const renderTemplate = (obj) => {
	const title = obj.title;
	const address = obj.address;
	const city = obj.city;
	const zipcode = obj.zipcode;
	const phone = obj.phone;
	const openingHours = obj.opening_hours;
	const link = obj.link;
	const services = obj.services;

	return `
	<div class="card-dealer card-dealer--info-window">
		<h4 class="card-dealer__title">
			<span class="card-dealer__title--highlight">Arturo</span>
			${title}
		</h4>

	<div class="card-dealer__row">
		<div class="card-dealer__left">
			<p>
			${address} <br />
			${zipcode} ${city} <br />
			${renderPhone(phone)} <br />
			</p>
		</div>

		<div class="card-dealer__right">
			${renderOpeningHours(openingHours)}
		</div>
	</div>
	<a href="${link}" target="_blank" class="btn btn--primary btn--has-icon">${
		arturo_vars.dealer_visit_website
	}</a>
</div>`;
};

const resetMarkers = () => {
	// Show all markers, depending on filters
	const bounds = new google.maps.LatLngBounds();
	let dealerCards = [];

	// Loop through all markers and create bounds
	$.each(markers, function (i, marker) {
		// var latlng = new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng());
		this.hiddenBySearch = false;

		// Make marker visible
		this.setVisible(true);
		dealerCards.push(this);

		// bounds.extend(latlng);
	});

	$(".dealer-list").empty();
	$(".js-dealer-more").remove();

	for (var i = 0; i < dealerCards.length; i++) {
		console.log("renderrrr");

		$(".dealer-list").append(renderDealerCard(dealerCards[i]));
	}

	focusLocations();
	// map.fitBounds(bounds); //auto-zoom
};

/**
 * Function compare distance between location and markers
 * @param {int} a
 * @param {int} b
 * @returns
 */
const compareDistance = (a, b) => {
	if (a.distance < b.distance) {
		return -1;
	}

	if (a.distance > b.distance) {
		return 1;
	}

	return 0;
};

// Disable enter
$(".js-submit-dealers").on("click", (e) => {
	e.preventDefault();
});
